import balanceAgent from '../../services/api/balanceAgent';
import BalanceStore from './balanceStore';

/**
 * The composition root of the balance store: the one place it meets the real agent. Other stores
 * that receive a balance push it in through `BalanceStore.accept`, handed to them as a port by their
 * own composition roots, so no store imports another.
 */
export const createBalanceStore = (): BalanceStore =>
  new BalanceStore({
    agent: balanceAgent,
  });
